import { apiGateway } from "@contexts";
import { GetBankTransactionChallengeResponse } from "@interfaces";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { AxiosError } from "axios";
import { ErrorType } from "@screens/FeaAuth/hooks/onQuestionChallengeError";

interface Props {
  onError: (error: AxiosError<ErrorType>) => void;
}

export const useCreateBankTransferChallenge = ({ onError }: Props) => {
  const onSuccess = useCallback(
    ({ simplifiedPaymentUrl }: GetBankTransactionChallengeResponse) => {
      window.location.href = simplifiedPaymentUrl;
    },
    [],
  );

  return useMutation({
    mutationFn: () =>
      apiGateway<GetBankTransactionChallengeResponse>({
        url: "/enrolment/bank-transfer-challenge",
        method: "POST",
      }),
    onSuccess,
    onError,
  });
};
